import { MoonStar, Sun } from "@untitled-ui/icons-react";
import { SwitchProps, useSwitch } from "@kirvanobr/switch";
import { useTheme } from "next-themes";
import { FC, useEffect, useState } from "react";

export interface ThemeSwitchProps {
  className?: string;
  classNames?: SwitchProps["classNames"];
}

export const ThemeSwitch: FC<ThemeSwitchProps> = () => {
  const [isMounted, setIsMounted] = useState(false);

  const { theme, setTheme } = useTheme();

  const onChange = () => {
    theme === "light" ? setTheme("dark") : setTheme("light");
  };

  const { Component, isSelected, getBaseProps, getInputProps, getWrapperProps } = useSwitch({
    isSelected: theme === "light",
    onChange,
  });

  useEffect(() => {
    setIsMounted(true);
  }, [isMounted]);

  if (!isMounted) return <div className="w-6 h-6" />;

  return (
    <Component
      {...getBaseProps({})}
      className="px-px transition-opacity hover:opacity-80 cursor-pointer fixed z-10 top-0 right-2"
    >
      <input {...getInputProps()} className="hidden" />

      <div {...getWrapperProps()} className="h-[45px] w-[45px] flex items-center justify-center">
        {isSelected ? <MoonStar fontSize={30} /> : <Sun fontSize={30} />}
      </div>
    </Component>
  );
};
